/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Account = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Account"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#5E1FF0"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m5.589 12.744a.833.833 0 0 0-1.178 0 6.24 6.24 0 0 1-8.822 0 .833.833 0 1 0-1.178 1.179 7.904 7.904 0 0 0 11.178 0 .834.834 0 0 0 0-1.179M8.667 7.833a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334m6.666 0a1.667 1.667 0 1 0 .001 3.333 1.667 1.667 0 0 0-.001-3.333"
      className="SVG"
    />
  </svg>
);

export const AccountIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'account-icon'}
      icon={Account}
      {...props}
      size={size}
    />
  );
};
